import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorSection } from 'react-anchor-navigation';
import './PageCalculator.scss';
import Content from '../../components/Content/Content';
import { Props } from './interfaces';
import { MediaContent } from '../../services/GlobalFunctions';
import FormContacts from '../../components/FormContacts/FormContacts';
import SliderLogos from '../../components/SliderLogos/SliderLogos';
import BlockCalculator from '../../components/BlockCalculator/BlockCalculator';
import BlockCarousel from '../../components/BlockCarousel/BlockCarousel';
import Title from '../../components/Title/Title';
import {APIWordpress} from "../../redux/services/APIRequestsWordpress";
import {ServiceData} from "../../redux/services/ServiceRedux";

const PageCalculator = ({ advantagesSlider, advantagesSliderTitle, advantagesSliderLoaded, widthWindow, alertLoaded }: Props) => {
  const [widthContent, setWidthContent] = useState('1280px');

  useEffect(() => {
    setWidthContent(widthWindow > 1439 ? '1440px' : '100vw');
    ServiceData.getAll({advantagesSliderLoaded, alertLoaded})
  }, [widthWindow]);

  return (
    <div className="page-calculator">

      {MediaContent(
        <BlockCalculator />,
        <Content
          block={<BlockCalculator />}
          padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 0, bottom: 40 } }}
        />
      )}

      <Content
        padding={{ paddingMain: { top: 80, bottom: 0 }, paddingMob: { top: 40, bottom: 0 } }}
        block={
          <>
            <Title
              center
              title={
                widthWindow > 720
                  ? 'Счастливый клиент — лучшая<br/> рекомендация'
                  : 'Счастливый<br/> клиент — лучшая<br/> рекомендация'
              }
              marginBottom={widthWindow > 720 ? 80 : ''}
            />
            <SliderLogos />
          </>
        }
      />

      <Content
        width={widthContent}
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={<BlockCarousel title={advantagesSliderTitle} list={advantagesSlider} />}
      />

      <AnchorSection id="form-send-calculator">
        <Content
          block={<FormContacts eventMetrika="form_club" sendAmoCRM />}
          padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        />
      </AnchorSection>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageCalculator));
